<i18n>
{
  "fr": {
    "configurator_add_to_cart_footer": {
      "title": "Vous aimerez surement :"
    }
  }
}
</i18n>

<template>
  <div
    v-if="products && products.length > 0"
    class="configurator-add-to-cart-footer"
  >
    <span class="configurator-add-to-cart-footer__title">
      {{ $t('configurator_add_to_cart_footer.title') }}
    </span>
    <div class="configurator-add-to-cart-footer__slider">
      <!-- ToDO Similar products slider -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfiguratorAddToCartFooter',
  props: {
    products: {
      type: Array,
      default: undefined,
    },
  },
};
</script>

<style scoped lang="scss">
.configurator-add-to-cart-footer {
  padding: 1.5em 2em;

  &__title {
    font-size: 1.25em;
    text-transform: uppercase;
    font-family: $font-default;
    font-weight: bold;
  }
}
</style>
